import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { Button } from "react-bootstrap";
import StatutsService from "../../services/StatutsService";
import PeriodiquesService from "../../services/PeriodiquesService";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";

export default function IndexPeriodiques() {

    //##########################/// METHODES ##########################///
    const [periodiques, setPeriodiques] = useState([])
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //get liste
    const fetchPeriodiques = async () => {
        await PeriodiquesService.index().then((res) => {
            setPeriodiques(res.data.liste_periodiques)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });

    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.periodiques_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                PeriodiquesService.delete(param,token).then((response) => {
                    if (response.data.erreur) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.erreur
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchPeriodiques()
                    }

                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                })
            }
        })
    }

    //Rendre actif ou inactif un user
    const updateStatut = async (id, statut, table) => {
        //let form = { id, statut, table }
        await StatutsService.changeStatut(id, statut, table,token).then(response => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur
                })
            } else {
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                })
                fetchPeriodiques()
            }
        }).catch(error => {
            console.log(error)
        })
    }

    useEffect(() => {
        fetchPeriodiques();
        $("#submenu-2").addClass("show")
    }, [])


    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Gestion</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Périodiques </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des Périodiques <Link className="btn btn-primary btn-sm" to={myroutes.periodiques_create} title="Ajouter" ><i className="fa fa-plus-circle"></i></Link> </h1>
                        </div>
                        <div className="col-auto">
                            <div className="page-utilities">
                                <div className="row g-2 justify-content-start justify-content-md-end align-items-center">

                                    <div className="col-auto">
                                        <a className="btn app-btn-primary" href="#">
                                            <i className="fas fa-file-excel"></i>&nbsp;
                                            Excel
                                        </a>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-danger" href="#">
                                            <i className="fas fa-file-pdf"></i>&nbsp;
                                            Pdf
                                        </a>
                                    </div>
                                </div>{/*//row*/}
                            </div>{/*//table-utilities*/}
                        </div>{/*//col-auto*/}
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="cell text-white">N°</th>
                                            <th className="cell text-white">Editeur  </th>
                                            <th className="cell text-white">Titre</th>
                                            <th className="cell text-white">Montant Periodique</th>
                                            <th className="cell text-white">Montant Abonnement</th>
                                            <th className="cell text-white">Statuts</th>
                                            <th className="cell text-white">Date modification</th>
                                            <th className="cell text-white">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider" style={{ textAlign: "left" }}>
                                        {periodiques.length > 0 && periodiques.map((item, index) => (
                                            <tr key={index}>
                                                <td className="cell">{index + 1}</td>
                                                <td className="cell">{item.editeur_raison_sociale} </td>
                                                <td className="cell"><span className="truncate">{item.titre_periodicite}</span></td>
                                                <td className="cell">
                                                    <NumericFormat value={item.montant_periodique} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
                                                </td>
                                                <td className="cell">
                                                    <NumericFormat value={item.montant_abonnement} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
                                                </td>
                                                <td className="cell"><span className={(item.get_statut === "ACTIF") ? "badge bg-success" : "badge bg-danger"}>{item.get_statut}</span></td>
                                                <td className="cell"><span>{dayjs(item.updated_at).format("DD/MM/YYYY H:m:s")} par </span>
                                                    <span className="notex">{item.updated_by ? item.nom : ''} {item.updated_by ? item.prenoms : ''}</span>
                                                </td>
                                                <td className="cell d-flex">
                                                    <Button className={item.get_statut === "ACTIF" ? "btn btn-sm btn-success" : "btn btn-sm btn-dark"} onClick={() => updateStatut(item.id, item.get_statut === "ACTIF" ? "desactivation" : "activation", "periodiques")} title="Changer le statut">
                                                        <i className={item.get_statut === "ACTIF" ? "fas fa-eye" : "fas fa-eye-slash"}></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-primary" onClick={() => goToEdit(item.id)} title="Modifier">
                                                        <i className="fas fa-edit"></i></Button>&nbsp;&nbsp;
                                                    <Button className="btn btn-sm btn-danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                        <i className="fas fa-trash"></i></Button>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                    {/*//End table-content*/}


                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}